/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getOrganizationSiteMetaData } from '../fn/organization-sites/get-organization-site-meta-data';
import { GetOrganizationSiteMetaData$Params } from '../fn/organization-sites/get-organization-site-meta-data';
import { OrganizationSiteMetaDataResponse } from '../models/organization-site-meta-data-response';
import { putOrganizationSiteMetaData } from '../fn/organization-sites/put-organization-site-meta-data';
import { PutOrganizationSiteMetaData$Params } from '../fn/organization-sites/put-organization-site-meta-data';

@Injectable({ providedIn: 'root' })
export class OrganizationSitesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `putOrganizationSiteMetaData()` */
  static readonly PutOrganizationSiteMetaDataPath = '/organizations/{organizationKey}/organization-sites/{organizationSiteKey}/metadata';

  /**
   * Add metadata to an organization site.
   *
   * Update or add a new metadata entry to an organization site. This
   * can be used to store additional information which is not part of
   * the standard organization site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putOrganizationSiteMetaData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putOrganizationSiteMetaData$Response(params: PutOrganizationSiteMetaData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = putOrganizationSiteMetaData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add metadata to an organization site.
   *
   * Update or add a new metadata entry to an organization site. This
   * can be used to store additional information which is not part of
   * the standard organization site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putOrganizationSiteMetaData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putOrganizationSiteMetaData(params: PutOrganizationSiteMetaData$Params, context?: HttpContext): Observable<void> {
    const resp = this.putOrganizationSiteMetaData$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOrganizationSiteMetaData()` */
  static readonly GetOrganizationSiteMetaDataPath = '/organizations/{organizationKey}/organization-sites/{organizationSiteKey}/metadata/{metaDataKey}';

  /**
   * Get the metadata of an organization site.
   *
   * Get the metadata of an organization site. This can be used to
   * retrieve additional information which is not part of the standard
   * organization site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrganizationSiteMetaData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationSiteMetaData$Response(params: GetOrganizationSiteMetaData$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationSiteMetaDataResponse>> {
    const obs = getOrganizationSiteMetaData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the metadata of an organization site.
   *
   * Get the metadata of an organization site. This can be used to
   * retrieve additional information which is not part of the standard
   * organization site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrganizationSiteMetaData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrganizationSiteMetaData(params: GetOrganizationSiteMetaData$Params, context?: HttpContext): Observable<OrganizationSiteMetaDataResponse> {
    const resp = this.getOrganizationSiteMetaData$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationSiteMetaDataResponse>): OrganizationSiteMetaDataResponse => r.body)
    );
  }

}
